/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { IntlProvider } from 'react-intl';
import { translationMessages } from './i18n';
import { makeSelectLocale } from './selectors';
import { useSelector } from 'react-redux';
import { useInjectReducer } from '../../store/injectReducer';
import { LANGUAGE_REDUCER_KEY } from './constants';
import languageProviderReducer from './reducer';

const stateSelector = createStructuredSelector({
  locale: makeSelectLocale,
});

const LanguageProvider = props => {
  useInjectReducer({ key: LANGUAGE_REDUCER_KEY, reducer: languageProviderReducer });
  const { locale } = useSelector(stateSelector);
  const messagesObj = translationMessages[locale];

  return (
    <IntlProvider key={locale} locale={locale} messages={messagesObj}>
      {React.Children.only(props.children)}
    </IntlProvider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default LanguageProvider;
